import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import {ImprimirControlComponent } from './imprimir-control.component';
import { ImprimirInformeCabeceraSharedModule } from '../partes/informe-cabecera/imprimir-informe-cabecera.module.share';



@NgModule({
    declarations: [ImprimirControlComponent],
    imports: [ 
        CommonModule,
        ImprimirInformeCabeceraSharedModule,
        ButtonModule 
    ],
    exports: [ ImprimirControlComponent ],
    providers: [],
})
export class ImprimirControlSharedModule {}